import {computed, signal} from "@preact/signals-react";

export const appUser = signal({})

export const appAvatar = computed(() => appUser.value?.avatar || '')
export const appUsername = computed(() => appUser.value?.username || '')
export const appUserEmail = computed(() => appUser.value?.email || '')
export const appUserRole = computed(() => appUser.value?.role || '')